<template>
  <div id="app">
    <div class="error text-primary bg-no-repeat h-screen bg-cover">
      <div
        class="absolute header pt-10 h-20 md:h-24 tracking-wide table-cell pl-8"
      >
        <img src="../assets/images/logo.svg" alt="Goldenrace Foundation" />
      </div>
      <div class="flex flex-row mx-6 justify-center items-center h-full container mx-auto">
        <div class="content flex flex-col text-primary md:w-4/6">
          <p class="texto-caveat block lg:hidden text-vendor-pink text-5xl">
            404
          </p>
          <p class="title text-7xl texto-caveat mb-6">Sorry!</p>
          <p class="text-xl leading-loose tracking-wide">
            We cannot show you that page.
          </p>
          <br />
          <p class="texto-roboto font-error">
            It could be a broken link, someone might have deleted the page, or you
            don't have permission to view it.
          </p>
          <router-link
            to="/"
            class="font-bold text-lg mt-6 texto-roboto text-primary text-center rounded-full border-primary border py-3 w-48"
          >
            Back To Home
          </router-link>
        </div>
        <div class="text-404 hidden lg:block">
          <p class="texto-caveat text-vendor-pink text-13xl">404</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  metaInfo: {
    title: 'Error'
  },
};
</script>

<style scoped>
.font-error {
  line-height: 170%;
  font-size: 16px;
  letter-spacing: 0.4px;
}

@media screen and (min-width: 767px) {
  .font-error {
    font-size: 20px;
  }
}

.error {
  background-image: url("../assets/images/background-error.png");
}
</style>
